/**
 * Supplier type values
 */
export enum SupplierTypeEnum {
	VEHICLES = 'vehicles',
	SPARE_PARTS = 'spare_parts',
	TIRES = 'tires',
	ACCESSORIES = 'accessories',
	MAINTENANCE = 'maintenance',
	BODY_WORK = 'body_work',
	DETAILING = 'detailing',
	VALETING = 'valeting',
	TRANSPORTATION = 'transportation',
	ROAD_WORTHY_CHECKS = 'road_worthy_checks',
	INSURANCE = 'insurance',
	FUEL = 'fuel',
	CHARGING_EQUIPMENT = 'charging_equipment',
	TOLL_SERVICES = 'toll_services',
	TELEMATICS = 'telematics',
	STORAGE = 'storage',
	OTHER = 'other',
}
